import { ClassNameMap } from '@material-ui/core/styles/withStyles'
import classNames from 'classnames'
import { mergeWith } from 'lodash'

export const combineStyles = (...styles: (ClassNameMap | false)[]) =>
  mergeWith({}, ...styles, (objVal: string, srcVal: string) => classNames(objVal, srcVal))
